var map = {
	"./01-s.jpg": "D37o",
	"./02-s.jpg": "77VX",
	"./03-s.jpg": "/q6K",
	"./04-s.jpg": "OnGx",
	"./05-s.jpg": "szEJ",
	"./06-s.jpg": "8S2b",
	"./07-s.jpg": "kiTz",
	"./08-s.jpg": "Dl04",
	"./09-s.jpg": "rsN+",
	"./10-s.jpg": "+fdp",
	"./11-s.jpg": "lns+",
	"./12-s.jpg": "1zbC",
	"./13-s.jpg": "gqAm",
	"./14-s.jpg": "fU0H",
	"./15-s.jpg": "5bsd",
	"./16-s.jpg": "4R1l",
	"./17-s.jpg": "cKO2",
	"./18-s.jpg": "VUX9",
	"./19-s.jpg": "MqRX",
	"./20-s.jpg": "Vgsb",
	"./21-s.jpg": "kHLG",
	"./22-s.jpg": "kINZ",
	"./23-s.jpg": "7QxK",
	"./24-s.jpg": "fwNT",
	"./25-s.jpg": "f4Qe",
	"./26-s.jpg": "Ua1b",
	"./27-s.jpg": "Hufu",
	"./28-s.jpg": "of0P",
	"./29-s.jpg": "adRU",
	"./30-s.jpg": "v3ig",
	"./31-s.jpg": "QSvC",
	"./32-s.jpg": "e7/v",
	"./33-s.jpg": "PVdI",
	"./34-s.jpg": "TcmZ",
	"./35-s.jpg": "y+t4",
	"./36-s.jpg": "c4yY",
	"./37-s.jpg": "6JWZ",
	"./38-s.jpg": "hyb8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "S3ov";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects ^\.\/.*\-s\.jpg$
// module id = S3ov
// module chunks = 0